import {useLazyQuery} from '@apollo/client'
import gql from 'graphql-tag'
import {useSelector} from 'react-redux'
import {selectFilterDetailsLoading} from '../../../../../store/slices/breadCrumbsSlice'
import {useFilterManagement} from '../../../../../store/hooks/useFilterManagement'
import {usePersona} from '../../../../../store/hooks/persona'
import {getState} from '../../../../../shared/helpers/getState'
import {useStatesAndHealthConditions} from '../../../../../store/hooks/breadCrumbs'

const PopulationDensity = gql`
  query populationDensity($filters: Filters, $benefits: [BenefitEligibility]) {
    populationDensity(filters: $filters, benefits: $benefits) {
      populationDensity {
        state
        county
        fips
        count
        population
        snapEnrolled
        usdaSnapIndCount
        usdaSnapIndNotEnrolled
        enrolled
        notEnrolled
        benefits
        countyPopulation
        countyPercentage
        statePercentage
        countySnapEnrolledPercentage
        countySnapNotEnrolledPercentage
      }
      populationAggregation {
        state
        fips
        population
        count
        snapEnrolled
        usdaSnapIndCount
        usdaSnapIndNotEnrolled
        enrolled
        notEnrolled
        benefits
        statePopulation
        statePercentage
        usPercentage
        stateSnapEnrolledPercentage
        stateSnapNotEnrolledPercentage
        usSnapEnrolledPercentage
        usSnapNotEnrolledPercentage
      }
      missingGeoIds
    }
  }
`

export function useGetPopulationDensity() {
  const {getQueryParams, getOutreachParams} = useFilterManagement()

  const appliedFilterParams = getQueryParams()
  const {filters} = useStatesAndHealthConditions()
  const filterDetailsLoading = useSelector(selectFilterDetailsLoading)
  const {personas, personasToggle} = usePersona()
  const selectedPersonas = personasToggle ? {persona: personas} : {}

  // Get outreach params (benefits only for now)
  const outreach = getOutreachParams()
  const benefitsData = outreach.type === 'benefits' ? outreach.data : []

  const currentStateFromContext = filters && getState(filters)
  const [conditionalDensityQuery, {data, loading, error, refetch}] = useLazyQuery(PopulationDensity, {
    variables: {
      filters: {
        state: currentStateFromContext,
        ...appliedFilterParams,
        ...selectedPersonas
      },
      benefits: benefitsData
    },
    skip: filterDetailsLoading,
    partialRefetch: true,
    notifyOnNetworkStatusChange: true
  })

  return [conditionalDensityQuery, {data: data?.populationDensity, loading, error, refetch}]
}
